import React from "react";
import ExportOptions from "../GenericComponents/ExportOptions";

function AccountsExportBar(props) {
  return (
    <div className="accounts-export-bar mt-3 flex flex-wrap items-center justify-between gap-3 rounded-[12px] border border-[#E5E7EB] bg-white px-4 py-3 shadow-sm">
      <div className="min-w-0">
        <p className="text-xs font-semibold text-gray-700">Export</p>
        <p className="text-[11px] text-gray-500">Download the current accounts list</p>
      </div>
      <div className="accounts-export-actions flex flex-wrap items-center justify-end gap-2">
        <ExportOptions premium {...props} />
      </div>
    </div>
  );
}

export default AccountsExportBar;
